export const containerColors = ['#FFFFFF3A', '#FFFFFF15'];
